import React from 'react';

export default function Icon({name}) {
	if(name == 'loader') {
		return <i className='fa fa-hourglass'></i>
	} else {
		var css = 'fa fa-' + name;
		return <i className={ css }></i>
	}
}


// WEBPACK FOOTER //
// ./src/modules/utils/icon.js